import React from "react";
import { useNavigate } from "react-router-dom";

export default function Report() {
  const navigate = useNavigate();

  React.useEffect(() => {
    navigate("/landing");
  }, [navigate]);

  return null;
}
